<template>
  <div class="content-wrapper" style="overflow: hidden;">
        <div class="form-wrapper">
            <div class="form">
                <router-link class="nav-link" :to="{name: 'food'}" style="margin-left: 25px">
                    <i class="fas fa-arrow-left back-btn"></i>
                </router-link>

                <h3 class="form-title">ADD MENU</h3>
                <label>
                    <input name="name" required="" placeholder="" type="text" class="input" v-model="nama">
                    <span>Food Name</span>
                    <p class="text-danger mt-1">{{ errName }}</p>
                </label> 
                    
                <label>
                    <select name="restaurant_id" id="restaurant_id" class="input" v-model="type" >
                        <option value="">Select Food Category</option>
                        <option v-for="ctg in category" v-bind:value="ctg.id" v-bind:key="ctg.id">{{ ctg.name }}</option>                        
                    </select>
                    <span>Food Category</span>
                    <p class="text-danger mt-1">{{ errType }}</p>
                </label> 

                <label>
                    <textarea name="description" required="" rows="3" placeholder="" class="input01" v-model="description"></textarea>
                    <span>Description</span>
                </label>

                <label>
                    <input name="price" required="" placeholder="" type="number" class="input" v-model="price">
                    <span>Price</span>
                </label> 

                <div class="col d-flex justify-content-between">    
                    <label class="custum-file-upload" for="file">
                        <div class="icon">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24"><g stroke-width="0" id="SVGRepo_bgCarrier"></g><g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"> <path fill="" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z" clip-rule="evenodd" fill-rule="evenodd"></path> </g></svg>
                        </div>
                        <div class="text">
                            <span>Click to upload image</span>
                        </div>

                        <input name="image" type="file" id="file" ref="file" @input="handleSelects" accept="image/png, image/jpeg">
                        
                        {{ image_name }}
                        <p class="text-danger mt-1">{{ errImage }}</p>
                    </label>

                    <div v-for="img in images" :key="img">
                        <img :src="img" class="preview">
                    </div>
                </div>
                    
                <button class="fancy" @click="submitCategory">
                    <span class="top-key"></span>
                    <span class="text">submit</span>
                    <span class="bottom-key-1"></span>
                    <span class="bottom-key-2"></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'AddFoodView',
    data(){
        return {
            category: [],
            nama: '',
            type: '',
            description: '',
            price: 0,
            image_name: null,
            image: null,
            images: [],

        }
    },
    mounted(){
        this.getCategories()
    },
    methods: {
       async getCategories(){
            const validToken = this.$store.getters.GET_AUTH_TOKEN;
            const config = {
                headers: { Authorization: `Bearer ` + validToken}
            }


            try {
                let { data } = await axios.get('/category', config)
                this.category = data.data                
            } catch(e) {
                console.log(e)
            }
       },
       handleSelects(e) {
            this.images = [];
            this.image_name = e.target.files[0].name;
            this.image = e.target.files[0];
            let fileList = Array.prototype.slice.call(e.target.files);
            fileList.forEach(f => {
                if(!f.type.match("image.*")) {
                    return;
                }

                let reader = new FileReader();
                let that = this;

                reader.onload = function (e) {
                    that.images.push(e.target.result);
                }

                reader.readAsDataURL(f); 
            })
        },
        submitCategory(){
            const validToken = this.$store.getters.GET_AUTH_TOKEN;

            let formData = new FormData();
            formData.append('image', this.image);
            formData.append('category', this.type);
            formData.append('name', this.nama);
            formData.append('description', this.description);
            formData.append('price', this.price);

            axios.post('/food', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin': '*',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ` + validToken,
                }
            })
            .then(() => {
                this.$router.push('/food');
            }).catch(err => {
                console.log(err)
                this.errImage   = err.response.data.error.image[0];
                this.errType    = err.response.data.error.type[0];
                this.errName    = err.response.data.error.name[0];
            });

            setTimeout(() => {
                this.errName    = null;
                this.errImage   = null;
                this.errType    = null;
            }, 5000);
        },
    }
}
</script>

<style>

</style>